import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environment';
import { Test } from '../_models/test.model';

@Injectable({
  providedIn: 'root',
})
export class TestsService {
  testsUrl =  'api/Tests';
  testTypesUrl =  'api/TestTypes';
  getTestsByTypeIdUrl: string = 'api/Tests/GetTestsByTypeId';
  searchTestsByNameUrl: string = 'api/Tests/SearchByName';

  constructor(private http: HttpClient) {}

  getAllTestTypes(): Observable<any> {
    return this.http.get(this.testTypesUrl);
  }

  getAllTests(): Observable<any> {
    return this.http.get(this.testsUrl);
  }

  getTestsByTypeId(typeId: number): Observable<any> {
    let params = new HttpParams().set('typeId', typeId.toString())
    return this.http.get(this.getTestsByTypeIdUrl, {params});
  }

  addNewTest(test: Test): Observable<any> {
    return this.http.post(this.testsUrl, test);
  }

  deleteTest(id): Observable<any> {
    return this.http.delete(`${this.testsUrl}/${id}`);
  }

  getTestById(id): Observable<any> {
    return this.http.get(`${this.testsUrl}/${id}`);
  }

  updateTest(newTest: Test): Observable<any> {
    return this.http.put(this.testsUrl, newTest);
  }

  searchTestByName(centerName, typeId) {
    let params = new HttpParams()
    .set('name', centerName)
    .set('typeId', typeId);
    return this.http.get(this.searchTestsByNameUrl, {params});
  }
}
